import { render } from "./Project.vue?vue&type=template&id=257866a8"
import script from "./Project.vue?vue&type=script&lang=js"
export * from "./Project.vue?vue&type=script&lang=js"

import "./Project.vue?vue&type=style&index=0&id=257866a8&lang=css"
script.render = render

export default script